var ratingStars = '.feedback .raty-star.write img';
var negativeRatingThreshold = 3;

function alertLowFeedback($feedbackTip) {
  $feedbackTip.slideDown();
}

function removeLowFeedbackAlerts($feedbackTip) {
  $feedbackTip.slideUp();
}

function bindRatingStars() {
  $(document).on('click.ratingStars', ratingStars, function () {
    var $this = $(this);
    var rating = $this.attr('alt');
    var $feedbackTip = $this
      .closest('[data-feedback-order-id]')
      .find('div[data-feedback-tip=true]');

    var $form = $feedbackTip.closest('form');
    $form.find(':submit').prop('disabled', false);
    Reverb.Forms.reEnableDisabledFormSubmit($form);

    if (rating <= negativeRatingThreshold) {
      alertLowFeedback($feedbackTip);
    } else {
      removeLowFeedbackAlerts($feedbackTip);
    }
  });
}

module.exports = {
  init: bindRatingStars,
};



// WEBPACK FOOTER //
// ./javascripts/components/legacy/feedback_tips.js